import React from "react";
import MainFrame from "../../components/mainFrame";
import { Box, Button, IconButton, TableRow } from "@mui/material";
import styled from "@emotion/styled";
import StickyTable from "../../components/table";
import Navbar from "../../components/navbar";
import { Cell } from "../../components/table/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { useModal } from "../../components/modal";
import { DeleteModal } from "../../components/appbar/modal";
import { smallButton } from "../../components/Button";
import AddModal from "./modal";
import { Helmet } from "react-helmet";
import {
  useDeleteCategoryMutation,
  useGetCaategoriesQuery,
} from "../../app/services/categories.api";

const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});
function Categories() {
  const { setShow, setContent } = useModal();

  const { data: categories } = useGetCaategoriesQuery({});
  const [deleteCategory] = useDeleteCategoryMutation();

  function handleOpenModal(type: string, id?: string) {
    if (type === "edit" && id) {
      setContent({
        title: " ویرایش دسته",
        body: <AddModal defaultValue={categories?.entities[id]} />,
      });
    }
    if (type === "add") {
      setContent({
        title: " افزودن دسته",
        body: <AddModal />,
      });
    }
    if (type === "delete" && id) {
      setContent({
        title: "حذف دسته",
        body: (
          <DeleteModal
            handleDelete={() =>
              deleteCategory({ categoryId: id })
                .unwrap()
                .then(() => {
                  setShow(false);
                })
                .catch((err) => {})
            }
          />
        ),
      });
    }
    setShow(true);
  }
  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> دسته بندی ها | پنل ادمین yaadin</title>
      </Helmet>
      <Navbar title="دسته بندی">
        <Button
          onClick={() => handleOpenModal("add")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <AddIcon />
          افزودن دسته
        </Button>
      </Navbar>
      <StickyTable
        headers={[{ name: "نام" }, { name: "توضیحات" }]}
        length={0}
        operations={true}
      >
        {categories?.ids.map((id, indx) => {
          const category = categories.entities[id];
          return (
            <TableRow hover role="checkbox" tabIndex={-1} key={id}>
              <Cell
                sx={{
                  "&.MuiTableCell-root": {
                    color: "divider",
                    fontSize: ".8rem",
                  },
                }}
              >
                {indx + 1}
              </Cell>
              <Cell width="50%">{category.title}</Cell>
              <Cell>{category.desc}</Cell>
              <Cell
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton onClick={() => handleOpenModal("edit", id)}>
                  <EditIcon sx={{ color: "divider" }} />
                </IconButton>
                <IconButton onClick={() => handleOpenModal("delete", id)}>
                  <DeleteIcon sx={{ color: "divider" }} />
                </IconButton>
              </Cell>
            </TableRow>
          );
        })}
      </StickyTable>
    </Container>
  );
}

export default MainFrame(Categories);
